import { Injectable, computed, signal } from '@angular/core';
import type { GridCommand } from './grid-command.interface';

/** Pilha de comandos (Command Pattern) para desfazer/refazer mutações locais do grid. */
@Injectable()
export class GridCommandManager {
  private readonly _undoStack = signal<readonly GridCommand[]>([]);
  private readonly _redoStack = signal<readonly GridCommand[]>([]);

  readonly canUndo = computed(() => this._undoStack().length > 0);
  readonly canRedo = computed(() => this._redoStack().length > 0);

  execute(command: GridCommand): void {
    command.execute();
    this._undoStack.set([...this._undoStack(), command]);
    this._redoStack.set([]);
  }

  undo(): void {
    const stack = this._undoStack();
    const command = stack[stack.length - 1];
    if (!command) return;

    command.undo();
    this._undoStack.set(stack.slice(0, -1));
    this._redoStack.set([...this._redoStack(), command]);
  }

  redo(): void {
    const stack = this._redoStack();
    const command = stack[stack.length - 1];
    if (!command) return;

    command.execute();
    this._redoStack.set(stack.slice(0, -1));
    this._undoStack.set([...this._undoStack(), command]);
  }

  clear(): void {
    this._undoStack.set([]);
    this._redoStack.set([]);
  }
}
